import { UserService } from './../../_services/user.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  CustomStepCategoryEnum,
  FunnelInputTypeEnum,
  OfferIntents,
  OfferTypes,
  StepCategory,
  StepPopupActions,
  StepTemplate,
  StepTypePopupData,
  User,
} from '../../_models';

@Component({
  moduleId: module.id.toString(),
  selector: 'step-type-popup',
  templateUrl: './step-type-popup.component.html',
  styleUrls: ['./../steps.component.scss'],
})
export class StepTypePopupComponent implements OnInit {
  @Input('data') inputData: StepTypePopupData;
  @Output('save') onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output('cancel') onCancel: EventEmitter<any> = new EventEmitter<any>();
  user: User = null;

  stepPopupActions = StepPopupActions;
  selectedStepType: StepCategory = null;
  selectedIntent: OfferIntents = null;

  constructor(protected userService: UserService) {}

  ngOnInit() {
    this.fetchCurrentUser();
  }

  selectTemplate(step: StepTemplate): void {
    this.selectedStepType = step.type;

    if (this.isSurvey) {
      this.selectedIntent = step.offer_intent;
    } else {
      this.selectedIntent = null;
    }
  }

  isChecked(step: StepTemplate, index: number): boolean {
    // Pre selected first index if no step is selected
    if (index === 0 && !step.disabled && !this.selectedStepType) {
      this.selectedStepType = step.type;
      if (this.isSurvey) {
        this.selectedIntent = step.offer_intent;
      }
    }

    return this.isSurvey ? this.selectedIntent === step.offer_intent : this.selectedStepType === step.type;
  }

  fetchCurrentUser(): void {
    this.userService.getCurrent().subscribe((currentUser) => {
      this.user = currentUser;
    });
  }

  onNext() {
    if (this.selectedStepType) {
      const routes = this.getRouteConfig(this.selectedStepType, this.selectedIntent);
      const path = this.inputData.use_existing_template ? routes.template : routes.base;

      this.onSave.emit({ path, selectedType: this.selectedStepType });
    }
  }

  get isSurvey(): boolean {
    return this.inputData.offer_type === OfferTypes.Survey;
  }

  protected getRouteConfig(stepType: StepCategory, offerIntent: OfferIntents = null) {
    const { offer_name, offer_type } = this.inputData;

    if (stepType === FunnelInputTypeEnum.EnterTroubleshooter) {
      const basePath = ['category', offer_type, 'step', stepType];
      return { base: basePath, template: basePath };
    }

    if (offer_type === OfferTypes.Survey && offerIntent) {
      return {
        base: ['admin', offer_name, 'intent', offerIntent, 'category', offer_type, 'step', stepType],
        template: ['admin', offer_name, 'intent', offerIntent, 'category', offer_type, 'template', stepType],
      };
    }

    if (offer_type === OfferTypes.CustomerPortal) {
      return {
        base: ['category', offer_type, 'step', stepType],
        template: ['category', offer_type, 'template', stepType],
      };
    }

    // Default case for Downsell, Upsell, and Support
    return {
      base: ['category', offer_type, 'step', stepType],
      template: ['category', offer_type, 'template', stepType],
    };
  }
}
